/**
 * Dmora Luxury E-commerce Interactive Features
 */

document.addEventListener('DOMContentLoaded', () => {
  initDmoraFeatures();
});

function initDmoraFeatures() {
  initDeliveryEstimates();
  initLiveViewers();
  initSizeChartModal();
  initStickyAddToCart();
  initFreeShippingBar();
}

/**
 * 1. Calculate and display dynamic Pakistani delivery date (2 - 4 business days)
 */
function initDeliveryEstimates() {
  const deliveryEls = document.querySelectorAll('[data-dmora-delivery-date]');
  if (!deliveryEls.length) return;

  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const today = new Date();
  
  const minDelivery = new Date(today);
  minDelivery.setDate(today.getDate() + 2);
  
  const maxDelivery = new Date(today);
  maxDelivery.setDate(today.getDate() + 4);

  const formattedDate = `${minDelivery.getDate()} ${months[minDelivery.getMonth()]} - ${maxDelivery.getDate()} ${months[maxDelivery.getMonth()]}`;

  deliveryEls.forEach(el => {
    el.textContent = formattedDate;
  });
}

/**
 * 2. Live Viewing Counter with subtle natural fluctuations
 */
function initLiveViewers() {
  const viewerCountEls = document.querySelectorAll('[data-dmora-live-count]');
  if (!viewerCountEls.length) return;

  let currentCount = Math.floor(Math.random() * (22 - 11 + 1)) + 11;

  viewerCountEls.forEach(el => el.textContent = currentCount);

  setInterval(() => {
    const delta = Math.floor(Math.random() * 3) - 1; // -1, 0, or 1
    currentCount = Math.max(9, Math.min(28, currentCount + delta));
    viewerCountEls.forEach(el => el.textContent = currentCount);
  }, 7000);
}

/**
 * 3. Size Chart Modal Trigger & Tab Navigation
 */
function initSizeChartModal() {
  const modal = document.querySelector('#dmoraSizeModal');
  if (!modal) return;

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-dmora-size-trigger]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      modal.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      return;
    }

    const closeBtn = e.target.closest('[data-dmora-modal-close]');
    if (closeBtn && modal.contains(closeBtn)) {
      e.preventDefault();
      e.stopPropagation();
      modal.classList.remove('is-active');
      const hasOtherModal = document.querySelector('.modal-overlay.is-open, .product-modal-backdrop.is-open');
      if (!hasOtherModal) {
        document.body.style.overflow = '';
      }
      return;
    }

    if (e.target === modal) {
      modal.classList.remove('is-active');
      const hasOtherModal = document.querySelector('.modal-overlay.is-open, .product-modal-backdrop.is-open');
      if (!hasOtherModal) {
        document.body.style.overflow = '';
      }
    }
  });

  // Size chart tab switching
  const tabs = document.querySelectorAll('.dmora-size-tab');
  const panels = document.querySelectorAll('.dmora-size-panel');

  tabs.forEach(tab => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();
      const target = tab.dataset.tab;
      tabs.forEach(t => t.classList.remove('is-active'));
      panels.forEach(p => p.classList.add('hidden'));

      tab.classList.add('is-active');
      const activePanel = document.querySelector(`#size-panel-${target}`);
      if (activePanel) activePanel.classList.remove('hidden');
    });
  });
}

/**
 * 4. Sticky Add to Cart on Scroll
 */
function initStickyAddToCart() {
  const stickyBar = document.querySelector('#dmoraStickyAtc');
  const mainForm = document.querySelector('.product-form, .product__info-container form[action*="/cart/add"]');
  if (!stickyBar || !mainForm) return;

  const mainSubmitBtn = mainForm.querySelector('[type="submit"], [name="add"]');
  if (!mainSubmitBtn) return;

  // Intersection Observer to show sticky bar when main button scrolls out of view
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
    });
  }, { threshold: 0.1 });

  observer.observe(mainSubmitBtn);

  // Variant Synchronization
  const variantSelect = stickyBar.querySelector('#dmoraStickyVariantSelect');
  const stickyBtn = stickyBar.querySelector('#dmoraStickySubmitBtn');
  const stickyPrice = stickyBar.querySelector('#dmoraStickyPrice');

  if (variantSelect) {
    variantSelect.addEventListener('change', () => {
      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      if (selectedOption && stickyPrice) {
        const price = selectedOption.dataset.price;
        if (price) stickyPrice.textContent = price;
      }
    });
  }

  if (stickyBtn) {
    stickyBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = variantSelect ? variantSelect.value : stickyBtn.dataset.variantId;
      if (!variantId) return;

      stickyBtn.disabled = true;
      const originalText = stickyBtn.innerHTML;
      stickyBtn.innerHTML = `<span>Adding...</span>`;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        if (res.ok) {
          stickyBtn.innerHTML = `<span>✓ Added!</span>`;
          // Trigger theme cart drawer open if available
          if (document.querySelector('cart-drawer')) {
            document.querySelector('cart-drawer').open();
            // Publish pubsub cart update
            if (window.publish && window.PUB_SUB_EVENTS) {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'dmora-sticky' });
            }
          } else {
            window.location.href = '/cart';
          }
          setTimeout(() => {
            stickyBtn.innerHTML = originalText;
            stickyBtn.disabled = false;
          }, 2000);
        } else {
          stickyBtn.innerHTML = originalText;
          stickyBtn.disabled = false;
          window.location.href = '/cart';
        }
      } catch (err) {
        console.error('Add to cart failed', err);
        stickyBtn.innerHTML = originalText;
        stickyBtn.disabled = false;
      }
    });
  }
}

/**
 * 5. Dynamic Free Shipping Progress in Cart
 */
function initFreeShippingBar() {
  const FREE_SHIPPING_THRESHOLD = 350000; // in cents/paisa: Rs. 3500 (350000)

  async function updateShippingBar() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      
      const barContainers = document.querySelectorAll('.dmora-free-shipping-box');
      if (!barContainers.length) return;

      const totalPrice = cart.total_price;
      const remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - totalPrice);
      const percentage = Math.min(100, Math.round((totalPrice / FREE_SHIPPING_THRESHOLD) * 100));

      barContainers.forEach(container => {
        const textEl = container.querySelector('.dmora-free-shipping-text');
        const fillEl = container.querySelector('.dmora-progress-fill');

        if (fillEl) fillEl.style.width = `${percentage}%`;

        if (textEl) {
          if (remaining === 0) {
            textEl.innerHTML = `🎉 <strong>Congratulations!</strong> You got <strong>FREE SHIPPING</strong>!`;
          } else {
            const formattedRemaining = (remaining / 100).toLocaleString('en-PK', { style: 'currency', currency: 'PKR', maximumFractionDigits: 0 });
            textEl.innerHTML = `🚚 Add <strong>${formattedRemaining}</strong> more for <strong>FREE SHIPPING!</strong>`;
          }
        }
      });
    } catch (e) {
      console.warn('Could not update free shipping bar', e);
    }
  }

  // Subscribe to cart updates
  if (window.subscribe && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => updateShippingBar());
  }

  updateShippingBar();
}
